<template>
	<div>
		<van-icon name="close" color="#fff" size="18px" class="colse" @click="buttonClick"/>
		<div class="container" id="posterHtml">
			<img src="../../assets/icon/bj.png" width="100%" alt="">
			<img class="posterimg" src="https://gd1.alicdn.com/imgextra/i2/0/O1CN014khwfT1CPvscuaIyU_!!0-item_pic.jpg_400x400.jpg" alt="">
<!--			<span class="Nickname">七月与安生</span>-->
			<img class="posterimgs" src="../../assets/icon/Doll.png" alt="">
			<div class="title">QQ family腾讯公仔鼓力全开系列</div>
			<div class="money">￥<span class="mon">219</span></div>
			<div ><img class="code" src="../../assets/icon/code.png" alt=""></div>
			<div class="webank">
				<img src="../../assets/icon/logo.png" alt="">
				<span>更多好物，尽在微众银行商城</span>
			</div>
		</div>
		<van-button round color="#d80c18" size="small" block @click="imgDown()" class="margin-tb">保存到相册</van-button>
		<p class="title-bottom">保存到相册分享给好友</p>
	</div>
</template>

<script>
import html2canvas from "html2canvas"
import wx from 'weixin-js-sdk';
export default {
	props: {
		list: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			posterContent: '文案内容', // 文案内容
			posterImg: '', // 最终生成的海报图片
			posterImgName: '海报' // 最终生成的海报图片名称
		};
	},
	methods: {
		buttonClick() {
			this.$emit("click");
		},
		// 保存图片到本地
		imgDown () {
			// var img=this.posterImg;
			// var alink = document.createElement('a')
			// let blob = this.base64ToBlob(img)
			// alink.download = this.posterImgName // 图片名
			// alink.href = URL.createObjectURL(blob)
			// let evt = document.createEvent('HTMLEvents')
			// evt.initEvent('click', true, true)
			// alink.click();
			// this.$emit("click");
			let aLink = document.createElement('a')
			let blob = this.base64ToBlob(this.posterImg)
			let evt = document.createEvent('HTMLEvents')
			evt.initEvent('click', true, true)
			aLink.download = '二维码.jpg'
			aLink.href = URL.createObjectURL(blob)
			aLink.click()
		},
		//这里把图片转base64
		base64ToBlob (code) {
			let parts = code.split(';base64,')
			console.log(parts)
			let contentType = parts[0].split(':')[1]
			let raw = window.atob(parts[1])
			let rawLength = raw.length
			let uInt8Array = new Uint8Array(rawLength)
			for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i)
			}
			return new Blob([uInt8Array], {type: contentType})
		},
		canvas(){
			let that = this
			let domObj = document.getElementById('posterHtml')
			html2canvas(domObj, {
				useCORS: true,
				allowTaint: false,
				logging: false,
				letterRendering: true,
				onclone (doc) {
					let e = doc.querySelector('#posterHtml')
					e.style.display = 'block'
				}
			}).then(canvas => {
				that.posterImg = canvas.toDataURL('image/png')
			})
		}
	},
	mounted(){
		setTimeout(() => {
			this.canvas();
		}, 500);
	},
};
</script>

<style lang="scss" scoped>
	.title-bottom{
		font-size: 22px;
		text-align: center;
		color: #ffffff;
	}
	.colse{
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
	}
	.container{
		background: #F1F1F1;
		position: relative;
		.posterimg{
			width: 90px;
			height: 90px;
			border-radius: 50%;
			position: absolute;
			top: 45px;
			left: 36px;
		}
		.Nickname{
			opacity: 0.95;
			font-size: 42px;
			font-family: FZZhengHeiS-DB-GB Regular, FZZhengHeiS-DB-GB Regular-Regular;
			font-weight: 400;
			color: #000000;
			letter-spacing: 1px;
			position: absolute;
			top: 175px;
			left: 460px;
		}
		.posterimgs{
			width: 335px;
			height: 402px;
			position: absolute;
			top: 280px;
			left: 50%;
			transform: translate(-50%,0);
		}
		.title{
			width: 332px;
			height: 80px;
			opacity: 0.95;
			font-size: 36px;
			font-family: PingFang SC Medium, PingFang SC Medium-Medium;
			font-weight: 500;
			text-align: center;
			color: #000000;
			line-height: 50px;
			letter-spacing: 1px;
			position: absolute;
			bottom: 320px;
			left: 50%;
			transform: translate(-50%,0);
		}
		.money{
			position: absolute;
			bottom: 255px;
			left: 50%;
			transform: translate(-50%,0);
			.mon{
				opacity: 0.95;
				font-size: 36px;
				font-family: SourceHanSansCN Regular, SourceHanSansCN Regular-Regular;
				font-weight: 400;
				color: #000000;
				line-height: 60px;
				letter-spacing: 1px;
			}
		}
		.code{
			width: 120px;
			height: 120px;
			position: absolute;
			bottom: 115px;
			left: 80px;
		}
		.webank{
			width: 100%;
			text-align: center;
			position: absolute;
			bottom: 32px;
			left: 50%;
			transform: translate(-50%,0);
			img{
				width: 202px;
				height: 21px;
			}
			span{
				display: block;
				height: 15px;
				font-size: 15px;
				font-family: SourceHanSansCN Light, SourceHanSansCN Light-Light;
				font-weight: 300;
				text-align: center;
				color: #595757;
				line-height: 44px;
				letter-spacing: 10px;
				padding-top: 13px;
			}
		}
	}
</style>
